import {
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges
} from "@angular/core";

@Component({
  selector: "app-minute-timer",
  templateUrl: "./minute_timer.html",
  styleUrls: ["./minute_timer.scss"]
})
export class MinuteTimerComponent implements OnInit, OnDestroy {
  @Input() minutes: number = 0;
  @Output("reset_timer") reset_timer = new EventEmitter();
  @Input() class = "";
  @Input() start = "";
  @Input() type: "increase" | "decrease" = "decrease";
  @Input() tooltip = "";
  seconds: number = 0;
  interval: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.start && changes.start.currentValue) {
      if (changes.start.currentValue) {
        this.startTimer();
      } else {
        this.resetTimer();
      }
    }
  }
  ngOnInit(): void {}

  startTimer() {
    clearInterval(this.interval);
    if (this.type === "decrease") {
      this.interval = setInterval(() => {
        if (this.minutes === 0 && this.seconds === 0) {
          this.resetTimer();
        } else if (this.seconds === 0) {
          this.minutes--;
          this.seconds = 59;
        } else {
          this.seconds--;
        }
        this.cdr.markForCheck();
      }, 1000);
    } else {
      this.interval = setInterval(() => {
        if (this.seconds < 59) {
          this.seconds++;
        } else {
          this.seconds = 0;
          this.minutes++;
        }
        this.cdr.markForCheck();
      }, 1000);
    }
  }

  resetTimer() {
    this.minutes = 1; // Cambia el número de minutos aquí
    this.seconds = 0;

    this.reset_timer.emit();
    clearInterval(this.interval);
  }

  ngOnDestroy() {
    this.resetTimer();
  }
}
